import BaseSection from '@/sections/base'
import AJAXKlaviyoForm from '@/core/ajaxKlaviyoForm'
import { wireNewsletterForm } from '@/core/wireNewsletterForm'
import NewsletterForm from '@/components/newsletterForm'

export default class NewsletterSignupSection extends BaseSection {
  static TYPE = 'newsletter-signup'

  newsletterForm: NewsletterForm | null
  ajaxForm: AJAXKlaviyoForm | null

  constructor(container: HTMLElement) {
    super(container)

    const formEl = this.qs(NewsletterForm.SELECTOR)
    this.newsletterForm = null
    this.ajaxForm = null

    if (formEl) {
      this.newsletterForm = new NewsletterForm(formEl)
      this.ajaxForm = wireNewsletterForm(formEl, this.newsletterForm)
    }
  }

  onUnload() {
    this.newsletterForm?.destroy()
    this.ajaxForm?.destroy()

    super.onUnload()
  }
}
